import React, { FunctionComponent, useCallback } from 'react';

import { useSelector } from 'react-redux';

import { i18n } from '../../../../../helpers/i18n';
import { useActions } from '../../../../../hooks';
import { selectIsSharingZoomOverrideEnabled, toggleSharingZoomOverrideAction } from '../../../../settings';
import { SettingsTumbler } from './settings-tumbler';

export const SharingZoomActiveTumbler: FunctionComponent = () => {
    const { toggleSharingZoomOverride } = useActions({
        toggleSharingZoomOverride: toggleSharingZoomOverrideAction,
    });
    const isSharingZoomOverrideEnabled = useSelector(selectIsSharingZoomOverrideEnabled);

    const onChange = useCallback(() => toggleSharingZoomOverride(), [toggleSharingZoomOverride]);

    return (
        <SettingsTumbler
            label={i18n('settings-v2', 'sharing-zoom-active-tumbler-label')}
            checked={isSharingZoomOverrideEnabled}
            onChange={onChange}
            testId="sharing-zoom-override-tumbler"
        />
    );
};
